var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('h2',[_vm._v("Selbstauskünfte")]),_c('v-divider',{staticClass:"mb-5"}),_c('v-btn',{attrs:{"to":"/disclosure/new"}},[_vm._v("NEW")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }